module.exports = __webpack_public_path__ + "img/bannerBj.78814386.png";